import * as moment from "moment";
import NotificationBase from "../NotificationBase";
import {JobCreatedFromQuoteNotificationDataApiDto, NotificationBaseApiDto} from "../../../api/model/rest";
import JobCreatedFromQuoteNotificationData from "./JobCreatedFromQuoteNotificationData";

/**
 * Job created from quote notification class.
 */
export default class JobCreatedFromQuoteNotification extends NotificationBase {
	/**
	 * @param {string} id Notification id.
	 * @param {moment.Moment} visibleFrom Notification datetime.
	 * @param {boolean} read Flag if notification is marked as read.
	 * @param {"JOB_CREATED_FROM_QUOTE"} type Notification type, in this case always 'JOB_CREATED_FROM_QUOTE'.
	 * @param {JobCreatedFromQuoteNotificationData} data Job created from quote notification data object.
	 */
	constructor(readonly id: string,
		readonly visibleFrom: moment.Moment,
		readonly read: boolean,
		readonly type: string,
		readonly data: JobCreatedFromQuoteNotificationData) {
		super(id, visibleFrom, read, type);
	}

	static fromJson(json: NotificationBaseApiDto): JobCreatedFromQuoteNotification {
		return new JobCreatedFromQuoteNotification(json.id, moment(json.visibleFrom), json.read, json.type,
			JobCreatedFromQuoteNotificationData.fromJson(json.data as JobCreatedFromQuoteNotificationDataApiDto));
	}

	copy({id = this.id, dateTime = this.visibleFrom, read = this.read, type = this.type, data = this.data}) {
		return new JobCreatedFromQuoteNotification(id, dateTime, read, type, data);
	}
}
